import { useState, useEffect, useRef } from 'react';

const LINKS = ['About', 'Services', 'Showcase', 'Contact'];

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const headerRef = useRef(null);

  // One scroll-progress var (0 at top → 1 once you've scrolled ~a viewport)
  // drives the whole header: the wordmark scales down into the bar, and the
  // bar/nav fade in. Single element, no class toggle — so it can't pop/glitch.
  useEffect(() => {
    const el = headerRef.current;
    if (!el) return;
    let ticking = false;
    const apply = () => {
      const span = window.innerHeight * 0.85 || 1;
      const p = Math.min(1, Math.max(0, window.scrollY / span));
      el.style.setProperty('--p', p.toFixed(4));
      el.style.setProperty('--pe', p > 0.5 ? 'auto' : 'none'); // nav clickable only once visible
      ticking = false;
    };
    const onScroll = () => {
      if (!ticking) { ticking = true; requestAnimationFrame(apply); }
    };
    apply();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    };
  }, []);

  // lock body scroll while the mobile menu is open
  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [menuOpen]);

  const go = (e, id) => {
    e.preventDefault();
    setMenuOpen(false);
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <>
      <header ref={headerRef} className="site-header" style={{ '--p': 0, '--pe': 'none' }}>
        <a className="brand" href="#top" onClick={(e) => go(e, 'globe-section')}>
          <span className="brand-mark">Sinocom Global</span>
          <span className="brand-sub">Est. 1984</span>
        </a>

        <nav className="nav">
          {LINKS.map((item) => (
            <a
              key={item}
              href={`#${item.toLowerCase()}`}
              className={item === 'Contact' ? 'nav-cta' : undefined}
              onClick={(e) => go(e, item.toLowerCase())}
            >
              {item}
            </a>
          ))}
        </nav>

        <button
          className="menu-btn"
          aria-label={menuOpen ? 'Close menu' : 'Open menu'}
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen((v) => !v)}
        >
          {menuOpen ? '✕' : '☰'}
        </button>
      </header>

      <div className={`mobile-nav${menuOpen ? ' open' : ''}`}>
        {LINKS.map((item) => (
          <a key={item} href={`#${item.toLowerCase()}`} onClick={(e) => go(e, item.toLowerCase())}>
            {item}
          </a>
        ))}
      </div>
    </>
  );
}

export default Header;
